import React, {useEffect} from 'react';
import {Navigate, useParams} from 'react-router-dom';
import {isDeviceSmall} from 'shared/helpers/DeviceSize';
import {CartContent} from 'shared/components/Header/CartContent';
import useUI from 'shared/useUI';
import {SidebarStatus} from 'store/customer/UISlice';

export const Cart = () => {
    const isSmallDevice = isDeviceSmall();
    const {setRightSidebar} = useUI();
    const {jobId} = useParams();

    useEffect(() => {
        if (!isSmallDevice) {
            setRightSidebar(SidebarStatus.OPEN);
        }
    }, [isSmallDevice]);

    if (isSmallDevice) {
        return (
            <section className="mobile-cart sidebar sidebar-right">
                <CartContent />
            </section>
        );
    }

    return <Navigate to={`/v2/job/${jobId}/dashboard`} replace />;
};
